import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class RewardsService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    async rewardConfigurationGet(data) {
        const pos = getPosition();
        const response = await API.service('rewardConfigurationGet', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async rewardConfigurationInsert(data) {
        const pos = getPosition();
        const response = await API.service('rewardConfigurationInsert', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async rewardConfigurationUpdate(data) {
        const pos = getPosition();
        const response = await API.service('rewardConfigurationUpdate', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async rewardsPromotionsGet(data) {
        const pos = getPosition();
        const response = await API.service('rewardsPromotionsGet', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async rewardsPromotionsInsert(data) {
        const pos = getPosition();
        const response = await API.service('rewardsPromotionsInsert', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async rewardsPromotionsUpdate(data) {
        const pos = getPosition();
        const response = await API.service('rewardsPromotionsUpdate', data, pos, this.changeAlert, null, null);

        return response?.data
    }
}